import { useSearchParams } from 'react-router-dom'
import './SuccessPage.less'
import '../../Styles/buttons.less'
import useBriefContext from '../../Hooks/Brief/useBriefContext'
import { useEffect } from 'react'
import BusinessSuccessPage from './Business/SuccessPage'
import LeadFeedSuccessPage from './LeadFeed/LeadFeedSuccess'
import FallBackSuccessPage from './Business/FallbackSuccessPage'
import captureMessage from '../../Utilities/Errors/captureMessage'

const SuccessPage = (): JSX.Element => {
  const { setShowBizLayout, brief } = useBriefContext()
  const [searchParams] = useSearchParams()
  const briefType = searchParams.get('type')
  const venueName = searchParams.get('venue-name')
  const businessEventUUID = searchParams.get('business-event-uuid')
  const directEnquiry = briefType === 'enquiry'

  useEffect(() => {
    setShowBizLayout(true) // hide LF messaging
  }, [])

  if (briefType === 'business') {
    if (businessEventUUID) return <BusinessSuccessPage businessEventUUID={businessEventUUID} />

    captureMessage('Missing event UUID for biz brief submission success page')
    return <FallBackSuccessPage />
  }

  return (
    <LeadFeedSuccessPage
      brief={brief}
      directEnquiry={directEnquiry}
      directEnquiryVenueName={venueName}
    />
  )
}

export default SuccessPage
